module.exports = __webpack_public_path__ + "static/media/airplanePatient.46622b95.webp";